$(function() {
	i4_Decorator_loader.load();
});

var i4_Decorator_loader = {
	classes: {},
	load: function() {
		var $components = $('[data-i4-decorator]');
		var instances = [];

		// console.log('this.classes', this.classes);
		var classes = this.classes;

		$components.each((i, element) => {
			var decorators = $(element).attr('data-i4-decorator');
			var initialized = $(element).attr('data-i4-decorator--initialized');

			var classNames = [];
			if (decorators.indexOf(' ') > 0) {
				classNames = decorators.split(' ');
			} else {
				classNames.push(decorators);
			}

			if (!initialized) {
				for (var j = 0; j < classNames.length; j++) {
					const className = classNames[j].trim();
	  				if (window[className]) {
						instances.push(new window[className](element));
						$(element).attr('data-i4-decorator--initialized', true);
					} else if (classes[className]) {
						instances.push(new classes[className](element));
						$(element).attr('data-i4-decorator--initialized', true);
					} else {
						console.warn('Class not found: ' + className);
					}
				}
			}
		});

		$(instances).each(function(i, instance) {
			instance.init();
		});

		$(instances).each(function(i, instance) {
			if (typeof instance.sync === 'function') {
				instance.sync();
			}
		});
	},

	registerClass: function(stringClassName, className) {
		this.classes[stringClassName] = className;
	}
};
